export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hooks.hook("app:mounted", () => {
        document.documentElement.id = "";
    });
});
